import { forwardRef, Fragment } from "react";
import Box from "@mui/material/Box";
import classes from "./PrintContent.module.css";
import Typography from "@mui/material/Typography";
import {
  DateField,
  NumberField,
  RecordContextProvider,
  // usePermissions,
} from "react-admin";
import splitArrayToChunks from "../../../utils/splitArrayToChunks";

const PrintContent = forwardRef((props, ref) => {
  // eslint-disable-line max-len
  // const { permissions, isLoading } = usePermissions();

  return (
    <Box
      component="div"
      sx={{
        display: "none",
      }}
    >
      <Box ref={ref}>
        <style type="text/css" media="print">
          {`@page {
              width: 215.9mm;
              height: 139.7mm;
              size: 8.5in 5.5in portrait;
              margin: 0;
            }
            html, body {
              width: 215.9mm;
              height: 100%;
            }
            .page-break {
              display: block;
              page-break-after: always;
              break-after: page;
              height: 0;
            }
            .page-break:last-child {
              page-break-after: auto;
              break-after: auto;
            }
            .big-back::before {
              content: "";
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background-image: url('/atena-tiles.png');
              background-repeat: no-repeat;
              background-position: 50% 18%;
              background-size: 20% auto;
              opacity: 0.2;
              z-index: -1;
            }
          `}
        </style>
        {splitArrayToChunks(props.record.factory_debt_correction_items, 5).map(
          (arr, i, ori) => {
            return (
              <Fragment key={i}>
                <Box
                  className="big-back"
                  sx={{
                    position: "relative",
                    overflow: "hidden",
                    ...(i > 0 ? { mt: 2 } : {}),
                    fontSize: "12px",
                    py: 2,
                    px: 2,
                    display: "flex",
                    flexDirection: "column",
                    height: "139.7mm",
                    boxSizing: "border-box",
                    fontFamily: "Arial, Helvetica, sans-serif",
                  }}
                >
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        textTransform: "uppercase",
                        fontFamily: "Arial, Helvetica, sans-serif",
                      }}
                    >
                      {props.record.company.name}
                    </Typography>
                    <Box>
                      <Typography
                        variant="caption"
                        component="span"
                        sx={{
                          pr: 1,
                          fontFamily: "Arial, Helvetica, sans-serif",
                        }}
                      >
                        Print date:
                      </Typography>
                      <RecordContextProvider value={props.record}>
                        <DateField
                          source="print_date"
                          sx={{
                            fontWeight: "inherit",
                            fontSize: "12px",
                            fontFamily: "Arial, Helvetica, sans-serif",
                          }}
                          options={{
                            year: "numeric",
                            month: "short",
                            day: "2-digit",
                          }}
                        ></DateField>
                      </RecordContextProvider>
                    </Box>
                  </Box>
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      mb: 2,
                      textTransform: "uppercase",
                      borderBottom: "1px solid #000",
                      textAlign: "center",
                      fontFamily: "Arial, Helvetica, sans-serif",
                    }}
                  >
                    koreksi hutang
                  </Typography>
                  <table className={classes.headerSj}>
                    <thead>
                    <tr>
                      <th rowSpan={5} style={{ width: "70%" }}>
                        <div style={{ fontWeight: "400", marginBottom: "6px" }}>
                          KEPADA YTH:{" "}
                        </div>
                        <div style={{ paddingLeft: "16px", fontWeight: "400" }}>
                          {props.record.supplier.code}
                        </div>
                        <div style={{ paddingLeft: "16px" }}>
                          {props.record.supplier.name}
                        </div>
                      </th>
                    </tr>
                    <tr>
                      <th>No. Voucher</th>
                      <th>:</th>
                      <th>{props.record.code}</th>
                    </tr>
                    <tr>
                      <th>Tgl. Bukti</th>
                      <th>:</th>
                      <th>
                        <RecordContextProvider value={props.record}>
                          <DateField
                            source="date"
                            sx={{
                              fontWeight: "inherit",
                              fontSize: "12px",
                              fontFamily: "inherit",
                            }}
                            options={{
                              year: "numeric",
                              month: "short",
                              day: "2-digit",
                            }}
                          ></DateField>
                        </RecordContextProvider>
                      </th>
                    </tr>
                  </thead>
                </table>
                <Typography
                  variant="caption"
                  sx={{
                    mt: 2,
                    mb: 1,
                    fontFamily: "Arial, Helvetica, sans-serif",
                  }}
                >
                  Keterangan: {props.record.note}
                </Typography>
                <table
                  className={`${classes.tableSj} ${classes.factoryDebtCorrectionItems}`}
                >
                  <thead>
                    <tr>
                      <th>No. Bukti Surat Jalan</th>
                      <th>Kode COA</th>
                      <th>Nama COA</th>
                      <th style={{ textAlign: "right" }}>Nominal</th>
                    </tr>
                  </thead>
                  <tbody>
                    {arr.map((obj, idx) => {
                      return (
                        <tr key={obj.id}>
                          <td>{obj.purchase_order.code}</td>
                          <td>
                            {
                              props.record.factory_debt_correction_journals[1]
                                .chart_of_account.code
                            }
                          </td>
                          <td>
                            {
                              props.record.factory_debt_correction_journals[1]
                                .chart_of_account.name
                            }
                          </td>
                          <td style={{ textAlign: "right" }}>
                            <RecordContextProvider value={obj}>
                              <NumberField
                                source="amount"
                                sx={{
                                  fontWeight: "inherit",
                                  fontSize: "11px",
                                  fontFamily: "inherit",
                                }}
                              ></NumberField>
                            </RecordContextProvider>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td
                        colSpan={3}
                        style={{
                          textAlign: "right",
                          verticalAlign: "baseline",
                          fontWeight: "bold",
                          borderRight: "none",
                        }}
                      >
                        Total:
                      </td>
                      <td style={{ textAlign: "right" }}>
                        <RecordContextProvider value={props.record}>
                          <NumberField
                            source="total"
                            sx={{
                              fontWeight: "inherit",
                              fontSize: "11px",
                              fontFamily: "inherit",
                            }}
                          ></NumberField>
                        </RecordContextProvider>
                      </td>
                    </tr>
                  </tfoot>
                </table>
                <Typography
                  variant="caption"
                  sx={{
                    mt: "auto",
                    textTransform: "capitalize",
                    fontFamily: "Arial, Helvetica, sans-serif",
                  }}
                >
                  {"Terbilang: # " + props.record.total_in_words + " Rupiah #"}
                </Typography>
                <table
                  style={{
                    marginTop: "6px",
                  }}
                  className={`${classes.tableACC} ${classes.factoryDebtCorrectionSignatures}`}
                >
                  <thead>
                    <tr>
                      <th>Mengetahui</th>
                      <th colSpan={2}>Pemeriksa</th>
                    </tr>
                    <tr>
                      <th
                        style={{ textTransform: "uppercase", width: "33.33%" }}
                      >
                        Kepala Depo
                      </th>
                      <th
                        style={{ textTransform: "uppercase", width: "33.33%" }}
                      >
                        Akunting
                      </th>
                      <th
                        style={{ textTransform: "uppercase", width: "33.33%" }}
                      >
                        Administrasi
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </Box>
              <div className="page-break" />
              </Fragment>
            );
          }
        )}
      </Box>
    </Box>
  );
});
export default PrintContent;
